import { namespace as LocationsNamespace } from '@store/modules/locations.types';

import ProductsApiService from './_services/products.api.service';

import { MutationTypes, ActionTypes } from './store.types';

export { namespace } from './store.types';

export default {
  namespaced: true,
  state: {
    products: [],
    productsTotalCount: 0,
  },
  mutations: {
    [MutationTypes.SET_PRODUCTS](state, payload) {
      state.products = payload;
    },
    [MutationTypes.SET_PRODUCTS_TOTAL_COUNT](state, payload) {
      state.productsTotalCount = payload;
    },
  },
  actions: {
    async [ActionTypes.GET_PRODUCTS](
      { commit, rootState: { [LocationsNamespace]: l } },
      { suffix = l.suffix, ...rest },
    ) {
      const { totalCount, items } = await ProductsApiService.getProducts({ suffix, ...rest });

      commit(MutationTypes.SET_PRODUCTS, items);
      commit(MutationTypes.SET_PRODUCTS_TOTAL_COUNT, totalCount);
    },
  },
};
